import React, { useState } from "react";
import "react-phone-number-input/style.css";
import { Button, Col, Form, FormCheck, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../styles/register.css";
import { validateOwnerRegistration } from "../utils/validation/owner-validation";
import ownerRegister from "../services/owner-register";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const Registration = () => {
  const [formData, setFormData] = useState({
    ownerName: "",
    emailAddress: "",
    phoneNo: "",
    password: "",
    whatsApp: false,
  });
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [apiError, setApiError] = useState("");

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateOwnerRegistration(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      setApiError("");
      setLoading(true);
      const ownerData = {
        ownerName: formData.ownerName,
        emailAddress: formData.emailAddress,
        phoneNo: formData.phoneNo,
        whatsApp: formData.whatsApp ? "true" : "false",
        pwd: formData.password,
      };

      try {
        const response = await ownerRegister.register(ownerData);
        setLoading(false);
        setApiError("");

        const ownerId = response?.result?.owner_id;
        if (ownerId) {
          navigate("/customer-otp-verification", { state: { ownerId } });
        } else {
          setApiError("Registration successful but owner ID not found.");
        }
      } catch (error) {
        setLoading(false);
        setApiError(error.message || "An error occurred. Please try again.");
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <section className="registration-section register-user">
      <div className="container">
        <div className="login-form-wrap">
          {apiError && (
            <div className="mb-2 text-sm-center">
              <div className="alert-danger rounded p-3">{apiError}</div>
            </div>
          )}

          <h2 className="form-title">Create Account</h2>
          <p> Sign up now to start your journey.</p>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Customer Name<span className="imp-star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="ownerName"
                    placeholder="Enter your Customer Name"
                    value={formData.ownerName}
                    onChange={handleInputChange}
                    isInvalid={!!errors.ownerName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.ownerName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="emailAddress"
                    placeholder="Enter your email address"
                    value={formData.emailAddress}
                    onChange={handleInputChange}
                    isInvalid={!!errors.emailAddress}
                  />
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Contact Number<span className="imp-star">*</span>
                  </Form.Label>
                  <Form.Control
                    type="number"
                    name="phoneNo"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={10}
                    placeholder="Enter your contact number"
                    value={formData.phoneNo}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only digits and restrict to 10 characters
                      if (/^\d{0,10}$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    isInvalid={!!errors.phoneNo}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.phoneNo}
                  </Form.Control.Feedback>

                  <Form.Control.Feedback type="invalid">
                    {errors.phoneNo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    Password<span className="imp-star">*</span>
                  </Form.Label>
                  <div className="password-input-container">
                    <Form.Control
                      name="password"
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your Password"
                      value={formData.password}
                      onChange={handleInputChange}
                      isInvalid={!!errors.password}
                    />
                    <span
                      className="password-toggle-icon"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                  </div>
                  <Form.Control.Feedback type="invalid">
                    {errors.password}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col lg={6}>
                <Form.Group className="mb-3">
                  <div className="whatsapp-wrapper">
                    <Form.Check
                      type="switch"
                      id="whatsapp-toggle"
                      name="whatsApp"
                      checked={formData.whatsApp}
                      onChange={handleInputChange}
                    />
                    <span>Use WhatsApp?</span>
                  </div>
                </Form.Group>
              </Col>
              <Col lg={12}>
                <div className="mt-3 forget-password mb-3">
                  <FormCheck
                    type="checkbox"
                    id="terms-checkbox"
                    className="custom-checkbox"
                    label={
                      <>
                        I accept the{" "}
                        <a
                          href="/terms-condition"
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => e.stopPropagation()}
                        >
                          Terms & Conditions and Cancellation Policy
                        </a>
                      </>
                    }
                  />
                </div>
              </Col>
            </Row>

            <Button type="submit" className="btn orange-btn" disabled={loading}>
              {loading ? "Registering..." : "Register"}
            </Button>

            <div className="dont-have-account text-start">
              <span>Already have an account?</span>
              <Link to={"/login"} className="link-page">
                Log in
              </Link>
            </div>
          </Form>
        </div>
      </div>
    </section>
  );
};

export default Registration;
